import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const influxdb = defineConnector({
  identifier: "influxdb",
  name: "InfluxDB Cloud",
  tagLine: "Time series database platform",
  logo,
  protocol: "http",
  tags: ["data", "observability"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.cloud2\\.influxdata\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "Authorization", value: app.secret.apiKey, scheme: "Token" },
    ]),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [InfluxDB Cloud dashboard](https://cloud2.influxdata.com/), navigate to **API Tokens**, and create a new token.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "InfluxDB Cloud host",
          placeholder: "us-east-1-1.aws.cloud2.influxdata.com",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Copy and paste the API token into the field below",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/v2/me`,
  },
});
